import { api } from './auth.service';

// ════════════════════════════════════════════════════════════════════════════
// execucaoTecnica.service.js — r221
// ────────────────────────────────────────────────────────────────────────────
// Bate em /execucao-tecnica, que devolve exatamente o mesmo payload de
// /planejamento (mesma consulta no backend). O endpoint é separado só pela
// permissão: quem tem a rotina 'execucao-tecnica' não precisa ter também a
// rotina 'planejamento'.
// ════════════════════════════════════════════════════════════════════════════

const execucaoTecnicaService = {

  // Lista os negócios em fase técnica (browse). O recorte de etapas
  // (Execução / Qualidade / Validação Cliente / Acompanhamento) é da tela.
  listar: async () => {
    const res = await api.get('/execucao-tecnica');
    return res.data;
  },

  // r236: arvore de itens do projeto (topico -> atividades) + indicadores do
  // topo. Alimenta o modal de execucao.
  // r238: `colaboradorIds` recorta as horas lancadas por quem apontou. So vale
  // pra admin — pro resto o backend forca o proprio colaborador e ignora o
  // parametro, entao mandar ou nao mandar da no mesmo.
  // r239: virou lista (varios de uma vez). Vai como CSV num parametro so.
  obterArvore: async (id, colaboradorIds) => {
    const lista = (colaboradorIds || []).filter(Boolean);
    const res = await api.get(`/execucao-tecnica/${id}/arvore`, {
      params: lista.length ? { colaborador_id: lista.join(',') } : {},
    });
    return res.data;
  },
};

export default execucaoTecnicaService;
